import { useMemo } from "react";
import Echart from "./Echart";

const CostMixDonut = ({ carriers }) => {
  const data = useMemo(() => {
    return (carriers || [])
      .map((c) => ({
        name: c.label,
        value: Number(c.cost || 0),
      }))
      .filter((d) => d.value > 0);
  }, [carriers]);

  const option = useMemo(() => {
    if (!data.length) return null;

    return {
      tooltip: {
        trigger: "item",
        formatter: (p) =>
          `${p.name}<br/>$${p.value.toFixed(
            2
          )} (${p.percent}%)`,
      },
      legend: {
        bottom: 0,
        left: "center",
      },
      series: [
        {
          type: "pie",
          radius: ["55%", "75%"],
          itemStyle: {
            borderRadius: 8,
            borderColor: "#fff",
            borderWidth: 2,
          },
          label: {
            formatter: "{d}%",
            fontWeight: "bold",
          },
          data,
        },
      ],
    };
  }, [data]);

  if (!option)
    return (
      <div className="em-chart-card">
        <h3>Mix de Costos</h3>
        <div className="em-empty-chart">
          No hay datos
        </div>
      </div>
    );

  return (
    <div className="em-chart-card">
      <h3>Mix de Costos</h3>
      <Echart option={option} />
    </div>
  );
};

export default CostMixDonut;